import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  saveButton: {
    id: 'OBF1oa',
    defaultMessage: 'Save',
    description: 'Text for the save button',
  },
  cancelButton: {
    id: 'g33k9T',
    defaultMessage: 'Cancel',
    description: 'Text for the cancel button',
  },
  deleteButton: {
    id: 'fOG8Di',
    defaultMessage: 'Delete',
    description: 'Text for the delete button',
  },
  closeDrawer: {
    id: 'jZUMjv',
    defaultMessage: 'Close drawer',
    description: 'Aria label for the close button in the drawer header',
  },
  untitledWorkflow: {
    defaultMessage: 'Untitled Workflow',
    id: '8KxiyC',
    description: 'Default name for a workflow with no name',
  },
  defaultTriggerTitle: {
    description: 'Placeholder for the trigger selection dropdown',
    defaultMessage: 'Select trigger...',
    id: 'sCqq3R',
  },
  saveRuleError: {
    description: 'Error notification when saving a workflow rule step fails',
    defaultMessage: 'Failed to save this step. Please try again.',
    id: 'Qwmq2/',
  },
});
